import { render, staticRenderFns } from "./messageInfo.vue?vue&type=template&id=e23be78e&"
import script from "./messageInfo.vue?vue&type=script&lang=js&"
export * from "./messageInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports